// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"8c9d9249","213":"d460e2da","239":"07641345","381":"62a1dca1","455":"f3bb6c88","657":"65aaa367"}[chunkId] + ".chunk.js";
};